import React from "react";
import { mergeStyles } from "@fluentui/merge-styles";
import { MessageBar, MessageBarBody } from "@fluentui/react-components";
import { FONT_SIZE_SMALL } from "../../../config/fontSizes";

type Props = {
  code?: number;
  title: string;
  errorMessage?: string;
};

const wrapperClass = mergeStyles({
  minHeight: "10vh",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  boxSizing: "border-box",
  padding: "8px",
});

const messageBarClass = mergeStyles({
  width: "100%",
  boxSizing: "border-box",
  "& .fui-MessageBarBody": {
    fontSize: FONT_SIZE_SMALL,
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
});

const DisplayError: React.FC<Props> = (props) => {
  const { code, title, errorMessage  } = props;

  return (
    <div className={wrapperClass}>
      <MessageBar intent="warning" className={messageBarClass}>
        <MessageBarBody>
          <div>{title}</div>
          {errorMessage && <p>{errorMessage}</p>}
          {code && <div>Error code: {code}</div>}
        </MessageBarBody>
      </MessageBar>
    </div>
  );
};

export default DisplayError;
